var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack5Solid31({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69,7.06H6.84v3.1a8,8,0,0,0,0,.95.91.91,0,0,0,.36.57,1.23,1.23,0,0,0,.76.21,1.11,1.11,0,0,0,.74-.2A.76.76,0,0,0,9,11.2a5.55,5.55,0,0,0,.06-1V7.06h1.15v3a8,8,0,0,1-.09,1.46,1.62,1.62,0,0,1-.35.72,1.76,1.76,0,0,1-.67.47,3.06,3.06,0,0,1-1.1.17,3.15,3.15,0,0,1-1.25-.19,1.91,1.91,0,0,1-.67-.49,1.55,1.55,0,0,1-.32-.64,6.62,6.62,0,0,1-.11-1.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack5Solid31);
export default __webpack_public_path__ + "static/media/Symbolpack_5_solid_31.02e183e887a006c02f0349163f47733c.svg";
export { ForwardRef as ReactComponent };